import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';


class ProductStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.products = [];
  }

  handleLoadSuccess(products) {
    this.products = products;
    this.emitChange();
  }
  handleMOre(products) {
    for (var obj in this.products) {
      if (this.products[obj].name == products.name) {
        this.products[obj].entitiesList = products.entitiesList;
      }
    }
    this.emitChange();
  }
  get() {
    return this.products;
  }

  dehydrate() {
    return {
      products: this.products
    };
  }

  rehydrate(state) {
    this.products = state.products;
  }
}

ProductStore.storeName = 'ProductStore';
ProductStore.handlers = {
  [Actions.LOAD_PRODUCT_SUCCESS]: 'handleLoadSuccess',
  [Actions.LOAD_PRODUCTMORE_SUCCESS]: 'handleMOre',
};

export default ProductStore;


// WEBPACK FOOTER //
// ./src/stores/ProductStore.js